import { styled } from "styled-components";

export const ButtonWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
`;
